import { ContextMenu } from "@/components/ui";
import type { MatterTaskPlanTask } from "@/lib/types";
import type { ReactNode } from "react";

type MatterTaskPlanTaskContextMenuProps = {
  canDelete: boolean;
  canUpdate: boolean;
  onDelete: () => void;
  onEdit: () => void;
  task: MatterTaskPlanTask;
  trigger: ReactNode;
};

export function MatterTaskPlanTaskContextMenu({
  canDelete,
  canUpdate,
  onDelete,
  onEdit,
  task,
  trigger,
}: MatterTaskPlanTaskContextMenuProps) {
  return (
    <ContextMenu
      entityName="task"
      trigger={trigger}
      open={canUpdate ? { onSelect: onEdit } : false}
      copy={{ label: "Copy task title", value: task.title }}
      delete={canDelete ? { onSelect: onDelete } : false}
    />
  );
}
